export default __webpack_public_path__ + "static/media/fotoHiveDepois.d3c76aba.png";